import script from "./SideBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBanner.vue?vue&type=script&setup=true&lang=js"

import "./SideBanner.vue?vue&type=style&index=0&id=2d3d100c&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3d100c"]])

export default __exports__